import { PasswordResetForm } from './ui'

export const PasswordReset = {
    Form: PasswordResetForm
}